import axios from "axios";
import API_BASE_URL from "@/config/api";

const TOKEN_KEY = "cafe_auth_token";
const USER_KEY = "cafe_auth_user";

export default {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem(USER_KEY) || "null"),
    token: localStorage.getItem(TOKEN_KEY) || null,
  },
  getters: {
    isAuthenticated: (s) => !!s.token,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    LOGOUT(state) {
      state.user = null;
      state.token = null;
    },
  },
  actions: {
    async loginUser({ commit }, { email, password }) {
      try {
        const { data } = await axios.post(`${API_BASE_URL}/auth.php`, {
          email,
          password,
        });
        if (data.success && data.user && data.token) {
          localStorage.setItem(TOKEN_KEY, data.token);
          localStorage.setItem(USER_KEY, JSON.stringify(data.user));
          commit("SET_TOKEN", data.token);
          commit("SET_USER", data.user);
        } else {
          throw new Error(data.error || "Invalid credentials");
        }
      } catch (err) {
        throw new Error(err.response?.data?.error || "Invalid credentials");
      }
    },
    logoutUser({ commit }) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      commit("LOGOUT");
    },
  },
};
